import script from "./SkillStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillStep.vue?vue&type=script&setup=true&lang=js"

import "./SkillStep.vue?vue&type=style&index=0&id=61e23b77&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61e23b77"]])

export default __exports__